import React from 'react';
import './App.css';

import Header from './Header';
import GameBoard from "./GameBoard";
import Footer from "./Footer";

function App() {
  return (
    <>
      <Header />
      <GameBoard />
      <Footer />
    </>
  );
}

export default App;
